'use client'
import { FC } from 'react'
import { AppLayout, LoginPage } from '@/root/modules/tuuleliinid'
import { AUTH_HEADING_ID } from '@/root/modules/tuuleliinid/LoginPage/constants'
import { useCustomRouter, useGetTranslations } from '@/root/shared-hooks'
import { LoginPageTab } from '@/root/shared-types/ui/ui-types'

export const RegisterAndLoginPage: FC = () => {
  const { params } = useCustomRouter()
  const { getTranslation } = useGetTranslations()
  const view = (params?.tab as LoginPageTab) ?? 'signup'

  const headingText =
    view === 'signup'
      ? getTranslation('authCreateAccountTitle')
      : view === 'login'
        ? getTranslation('signInEnter')
        : getTranslation('forgotPassHeaderTitle')

  return (
    <AppLayout>
      <div className="bg-base-lightest flex grow flex-col items-center px-4 py-10">
        <h1 id={AUTH_HEADING_ID} className="text-primary-base mb-6 text-center text-2xl font-bold">
          {headingText}
        </h1>
        <div className={`flex w-full max-w-295 flex-col items-center rounded-2xl bg-white px-4 pb-14 pt-10 xs:px-8 ${view !== 'recovery' ? 'min-h-171' : ''}`}>
          <LoginPage />
        </div>
      </div>
    </AppLayout>
  )
}
